import React from 'react';

/**
 * Малюнки напрямків послуг.
 *
 * До цього кожен напрямок позначався іконкою з набору Font Awesome — сітка,
 * картка, щит, база даних, папір, рукостискання. Це стандартні піктограми
 * інтерфейсу, які стоять на десятках тисяч сайтів і нічого не кажуть про
 * медичне право: «база даних» однаково позначає і ЕСОЗ, і хостинг, і CRM.
 *
 * Тут — власні малюнки під кожен напрямок: структура закладу, ліцензія з
 * печаткою, знак охорони прав, кардіограма в системі, комплект документів,
 * терези. Усе намальовано лініями просто в розмітці: жодного файлу, жодного
 * запиту до мережі, будь-який розмір без втрати чіткості.
 *
 * Колір береться з тексту (`currentColor`), тож малюнок підхоплює той відтінок,
 * який заданий на картці, і не потребує окремої теми.
 */

const Frame = ({ children, className }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

// 01. Старт справи «під ключ» — структура закладу: засновник і два підрозділи.
const Structure = () => (
  <>
    <rect x="24" y="6" width="16" height="12" rx="2" />
    <rect x="6" y="44" width="18" height="12" rx="2" />
    <rect x="40" y="44" width="18" height="12" rx="2" />
    <path d="M32 18v10M15 44V34h34v10M32 28v6" />
    <circle cx="32" cy="31" r="1.6" fill="currentColor" stroke="none" />
  </>
);

// 02. Ліцензування — бланк із печаткою.
//
// Печатка тут навмисно з подвійним кільцем і стрічкою, а не з галочкою:
// галочка вже стоїть на малюнку документального супроводу, і два майже
// однакові документи в сусідніх картках читалися б як одна послуга двічі.
const License = () => (
  <>
    <path d="M12 6h26l10 10v26a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4Z" />
    <path d="M38 6v8a2 2 0 0 0 2 2h8" />
    <path d="M16 22h20M16 29h14" />
    <circle cx="42" cy="42" r="8" />
    <circle cx="42" cy="42" r="3.4" />
    <path d="M38 49v9l4-3 4 3v-9" />
  </>
);

// 03. Захист інтелектуальної власності — знак охорони під щитом.
const Shield = () => (
  <>
    <path d="M32 6 52 13v16c0 12-8.5 21-20 25C20.5 50 12 41 12 29V13L32 6Z" />
    <circle cx="32" cy="28" r="8.5" />
    <path d="M35.5 24.5A5 5 0 1 0 35.5 31.5" />
  </>
);

// 04. ЕСОЗ — кардіограма в електронній системі.
const Pulse = () => (
  <>
    <rect x="6" y="10" width="52" height="34" rx="4" />
    <path d="M6 20h52" />
    <circle cx="12" cy="15" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="17" cy="15" r="1.3" fill="currentColor" stroke="none" />
    <path d="M14 33h8l4-8 5 14 4-9h15" />
    <path d="M24 44v8M40 44v8M18 52h28" />
  </>
);

// 05. Документальний супровід — стос документів із перевіркою.
const Documents = () => (
  <>
    <rect x="20" y="4" width="30" height="36" rx="3" />
    <path d="M26 14h18M26 21h12M26 28h15" />
    <path d="M13 12v38a4 4 0 0 0 4 4h25" />
    <path d="M6 20v38a2 2 0 0 0 2 2h26" />
    <circle cx="47" cy="47" r="9" />
    <path d="m43 47 3 3 5-6" />
  </>
);

// 06. Юридичний аутсорсинг — терези: постійна рівновага, а не разова дія.
const Scales = () => (
  <>
    <path d="M32 8v40M20 54h24M26 48h12" />
    <path d="M12 18h40" />
    <circle cx="32" cy="13" r="2.4" fill="currentColor" stroke="none" />
    <path d="M14 18 7 34h14L14 18Z" />
    <path d="M50 18l-7 16h14l-7-16Z" />
  </>
);

const GLYPHS = [Structure, License, Shield, Pulse, Documents, Scales];

const ServiceGlyph = ({ index, className = 'w-14 h-14' }) => {
  const Glyph = GLYPHS[index] || GLYPHS[0];
  return (
    <Frame className={className}>
      <Glyph />
    </Frame>
  );
};

export default ServiceGlyph;
